




































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { ENTITY, START_LOADING, END_LOADING } from '@/main/store/listEditTypes';
import { PageMode } from '@/main/utils/pageMode';
import dayjs from 'dayjs';
import { httpRequest } from '@/main/services/httpRequest';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';
import { getColumnsNames, Table } from '@/main/utils/table';

import { entityId, NAME, DAILY_STATISTICS_BY_PAYMENT, TAB_NAMES, TABS, MAX_DAYS, MIN_DAYS } from './constants';
import { store } from './store/edit';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	provide() {
		return { pageMode: this.pageMode };
	},
	data() {
		return {
			tabNames: TAB_NAMES,
			cashierUrl: 'null' as string,
			fromDate: 'DateFrom',
			toDate: 'DateTo',
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];
			if (this.hasTabAccess(NAME, TABS.DAILY_STATISTICS_BY_PAYMENT)) tabItems.push(TAB_NAMES.DailyStatisticsByPayment);
			return _.pick(TABS, tabItems);
		},
		pageMode(): PageMode {
			return PageMode.EDIT;
		},
		tableListeners(): {} {
			return {
				'save-column-setting': this.saveColumnSetting,
			};
		},
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopId);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopId);
		},
	},
	methods: {
		async baseCreated() {
			this.entityId = entityId;
			await this.storeToPageManager();
		},
		entity() {
			return this.$store.dispatch(`${this.storeUri}/${ENTITY}`, { id: this.entityId });
		},
		loadedData() {
			this.loadSchemas();
			this.loadDataForGrid();
		},
		async tabClicked(tab: any) {
			this.loadDataForGrid(tab.$props.name);
		},
		async loadSchemas() {
			try {
				this.startLoading();
				await this.fetchTableSchemas([DAILY_STATISTICS_BY_PAYMENT]);
			} catch (error) {
				this.endLoading();
			} finally {
				this.endLoading();
			}
		},
		async searchData(isNewVersion: boolean) {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			if (this.WorkshopId == null || this.WorkshopId.length === 0) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
				return;
			}
			if (isMultipleWorkshopSelected(this.WorkshopId)) {
				const table = this.dependentTables.DailyStatisticsByPayment;
				await handleMultiWorkshopFilter(
					{ ...this, table },
					NAME,
					this.WorkshopId,
					() => ({
						WorkshopId: this.WorkshopId,
						DateFrom: this.DateFrom,
						DateTo: this.DateTo,
						ColumnSequence: getColumnsNames(table.columns.filter(x => x.isVisible === true)).join(','),
						LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
						IsNewVersion: isNewVersion,
					}),
				);
			} else {
				this.loadDataForGrid();
			}
		},
		async loadDataForGrid(tabName: string = '') {
			if (this.isValidDateRange()) {
				try {
					this.startLoading();
					if ((tabName && tabName === TABS.DAILY_STATISTICS_BY_PAYMENT.id)
					|| (!tabName && (this.activeTabName === null || this.activeTabName === TABS.DAILY_STATISTICS_BY_PAYMENT.id))) {
						await this.fetchTableData([DAILY_STATISTICS_BY_PAYMENT]);
					}
				} catch (error) {
					this.endLoading();
				} finally {
					this.endLoading();
				}
			}
		},

		validation(workshopId: any, DateFrom: any, DateTo: any, isNewVersion:any) {
			return `dateFrom=${DateFrom}&dateTo=${DateTo}&workshopId=${workshopId}&isNewVersion=${isNewVersion}`;
		},

		async exportData(isNewVersion: boolean) {
			if (this.isValidDateRange()) {
				try {
					if (this.WorkshopId == null || this.WorkshopId.length === 0) {
						this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
						return;
					}
					const columnsSeq = this.dependentTables.DailyStatisticsByPayment.columns.filter(x => x.isVisible === true).map(x => x.columnName);
					this.startLoading();
					const params = this.validation(this.WorkshopId, new Date(this.DateFrom!).toISOString(), new Date(this.DateTo!).toISOString(), isNewVersion);
					if (this.isMultipleWorkshopSelected) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
						});
					} else {
						await apiProvider.GetCashierReportExcel(params, columnsSeq, getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId));
					}
				} catch (error) {
					this.endLoading();
				} finally {
					this.endLoading();
				}
			}
		},
		async validateDates() {
			this.isValidDateRange();
		},
		isValidDateRange(): boolean {
			if (this.DateFrom && this.DateTo) {
				const daysDifferance = dayjs(new Date(this.DateTo)?.toDateString()).diff(dayjs(new Date(this.DateFrom)?.toDateString()), 'days');
				if (daysDifferance < MIN_DAYS) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					return false;
				} if (daysDifferance > MAX_DAYS) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('CR_MAX_DAYS_VALIDATION').replace('<DAYS>', `${MAX_DAYS}`) });
					return false;
				}
				return true;
			}
			this.showErrorAlert({ message: this.LocalizePopisPoli('CR_DATE_VALIDATION') });
			return false;
		},
		async saveColumnSetting(columns: string) {
			const gridId = this.dependentTables[DAILY_STATISTICS_BY_PAYMENT]?.gridId;
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await httpRequest.post(`Grid?gridId=${gridId}`, { userColumnsSettings: columns });
			this.fetchTableSchemas([DAILY_STATISTICS_BY_PAYMENT]);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},
	},
});
